import { render, staticRenderFns } from "./Demoresultadoseries.vue?vue&type=template&id=5492c47a&"
import script from "./Demoresultadoseries.vue?vue&type=script&lang=js&"
export * from "./Demoresultadoseries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports